module.exports = __webpack_public_path__ + "img/cn.36386d1d.png";